// extracted by mini-css-extract-plugin
export var box = "_9d-1";
export var checked = "_9d-2";
export var descriptionSpacer = "_9d-9";
export var disabled = "_9d-3";
export var icon = "_9d-6";
export var input = "_9d-0";
export var labelSpacer = "_9d-8";
export var medium = "_9d-5";
export var small = "_9d-4";
export var text = "_9d-7";